<template>
    <el-dialog
        width="650px"
        title="创建其他售卖国家的运营Asin(只会创建 Asin已存在|有销售价格|类目正常匹配 的Asin)"
        :visible.sync="visible"
        :before-close="handleClose"
        top="10vh"
        custom-class="customClass"
        append-to-body
    >
        <el-form ref="formData" :rules="rules" size="mini" label-width="130px">
            <el-checkbox-group v-model="states" class="reverseCheck">
                <template v-for="item in dataList">
                    <el-checkbox :disabled="item.exist === 1" :label="item.state">
                        <span v-show="item.exist === 1">(已存在)</span>
                        <span style="display: inline-block;width: 20px;text-align: left;">{{ item.state }}</span>
                    </el-checkbox>
                    <br/>
                    <br/>
                </template>

            </el-checkbox-group>
        </el-form>

        <el-row style="margin-top:17px; ">
            <el-button style="float:right;margin-left:6px;" size="mini" type="danger" plain @click="handleClose()">取消
            </el-button>
            <el-button style="float:right" size="mini" type="primary" @click="submitForm()" :loading="loading">确定
            </el-button>
        </el-row>
    </el-dialog>

</template>

<script>
import * as api from '@/api/advAnalys/advAnalys.js'
import {
    operating_asin_manager_sync_create_analysis,
    operating_asin_manager_sync_create_create
} from '@/api/advAnalys/advAnalys.js'

export default {
    name: 'specificationPackageModal',
    data() {
        return {
            visible: false,
            loading: false,
            states: [],
            rules: {},
            dataList: []
        }
    },
    methods: {
        openModal(data) {
            const tempData = JSON.parse(JSON.stringify(data))
            this.formData = tempData
            this.getData()
            this.visible = true
        },
        getData() {
            api.operating_asin_manager_sync_create_analysis({id: this.formData.id}).then((res) => {
                if (res.success) {
                    this.dataList = res.data || []
                } else {
                    this.$message.error(res.message)
                }
            })
        },
        submitForm() {
            this.loading = true
            if (this.states.length === 0) {
                this.$message({type: 'error', message: '请至少选择一个国家'})
                this.loading = false
                return
            }
            api.operating_asin_manager_sync_create_create({id: this.formData.id, states: this.states}).then(res => {
                this.loading = false
                if (res.code === 0) {

                    const h = this.$createElement

                    this.$notify({
                        title: '操作成功',
                        message: h('i', {style: 'color: teal'}, '操作成功' + res.data),
                    })

                    this.handleClose(true)
                } else {
                    this.$message({type: 'error', message: res.message})
                }
            }).catch(() => {
                this.loading = false
                this.$message({type: 'error', message: '网络出现问题，请刷新页面！'})
            })
        },

        // 关闭弹窗
        handleClose(isshow = false) {
            this.visible = false
            this.states = []
            this.dataList = []
            this.$emit('close-callback', isshow)
        }
    }
}
</script>

<style scoped>
/deep/ .customClass .el-dialog__title {
    display: inline-block;
    width: calc(100% - 30px);
    text-align: center;
}

.reverseCheck {
    .el-checkbox {
        width: 105px;
        display: flex;
        flex-flow: row-reverse;
        margin: 5px auto 0;

        .el-checkbox__label {
            font-size: 16px;
            width: 90px;
            text-align: right;
            margin-left: -80px;
        }

        .el-checkbox__inner {
            margin-top: 5px;
        }
    }
}

</style>
